const ResourcesSlider = (target) => {
  const SLIDER_WRAPPER_DATA_SELECTOR = '[data-slider-wrap]';
  const SLIDER_NEXT_BUTTON_SELECTOR = '[data-slider-next]';
  const SLIDER_PREV_BUTTON_SELECTOR = '[data-slider-prev]';

  const sliderParams = {
    slidesToShow: 4,
    infinite: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1180,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  const initSlider = ($el, params) => {
    $el.slick(params);
  };

  $('body').find(target).each((_, el) => {
    const $el = $(el);
    const params = $.extend({}, sliderParams, $(this).data('slider'))

    params.prevArrow = $el.closest(SLIDER_WRAPPER_DATA_SELECTOR).find(SLIDER_PREV_BUTTON_SELECTOR);
    params.nextArrow = $el.closest(SLIDER_WRAPPER_DATA_SELECTOR).find(SLIDER_NEXT_BUTTON_SELECTOR);

    initSlider($el, params);
  })
};

export default ResourcesSlider;



// WEBPACK FOOTER //
// ./scripts/components/ResourcesSlider.js